function checkOverwritePlayerId(): void {
	// Check if the player is already on puzzlist.com. If so, do nothing.
	const puzzlist = window.location.href.includes('puzzlist.com')
	if (puzzlist) return

	// If we've been passed a player ID in the query string, and they've never played before, use that as their
	// player ID going forward. If they have played before, we don't want to overwrite their player ID.
	const params = new URLSearchParams(window.location.search)
	const playerId = params.get('pid')
	const stats = localStorage.getItem('daily5_stats') // e.g. {"p":11,"sk":1,"b":1,"l":416,"s":41,"dst":[1,1,2,3,4],"bt":25}
	const statsObj = stats ? JSON.parse(stats) : null
	const hasPlayed = statsObj && statsObj.p >= 1 // Check if the player has played at least one game
	// Check if player ID looks like the correct format (UUID v4)
	const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
		playerId || ''
	)

	if (!hasPlayed && playerId && isUUID) {
		localStorage.setItem('pid', playerId)
	}
}

export default checkOverwritePlayerId
